export const customFieldDateForDisplay = (value) => {
    if (!value) return "";
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value));
    return match ? `${match[3]}/${match[2]}/${match[1]}` : "";
};

export const customFieldDateForApi = (value) => {
    if (!value) return null;
    const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(String(value));
    if (!match) return null;
    return `${match[3]}-${match[2]}-${match[1]}`;
};

export const isValidCustomFieldDate = (value) => {
    if (!value) return true;
    const apiDate = customFieldDateForApi(value);
    if (!apiDate) return false;
    const [year, month, day] = apiDate.split("-").map(Number);
    const date = new Date(Date.UTC(year, month - 1, day));
    return date.getUTCFullYear() === year
        && date.getUTCMonth() + 1 === month
        && date.getUTCDate() === day;
};

export const customFieldDisplayValue = (field) => {
    if (field.response === null || field.response === undefined || field.response === "") {
        return "";
    }
    if (String(field.response).trim().toLowerCase() === "not provided") return "";
    if (field.field_type === "YES_NO") return field.response ? "Yes" : "No";
    if (field.field_type === "DATE") return customFieldDateForDisplay(field.response);
    return String(field.response);
};
